import { useState } from "react";
import { URL } from "../../Common/APIURL";

// ─────────────────────────────────────────────
// LOCATION CARD — portrait style
// ─────────────────────────────────────────────

const LocationCard = ({ location, isSelected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(location)}
    style={{ height: "350px", display: "block", position: "relative" }}
    className={`group w-full rounded-2xl overflow-hidden transition-all duration-300 text-left
      shadow-[0px_20px_40px_rgba(24,28,29,0.08)]
      ${isSelected
        ? "ring-4 ring-[#08757c] ring-offset-2"
        : "hover:ring-2 hover:ring-[#08757c]/40 hover:ring-offset-1"}`}
  >
    {/* Background — image or teal gradient fallback */}
    {location.iconPath ? (
      <img
        src={`${URL}${location.iconPath}`}
        alt={location.cityName}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
        className="transition-transform duration-700 group-hover:scale-105"
        onError={(e) => { e.target.style.display = "none"; }}
      />
    ) : (
      <div style={{ position: "absolute", inset: 0 }} className="bg-gradient-to-br from-[#08757c] to-[#005b60]" />
    )}

    {/* Dark overlay */}
    <div style={{ position: "absolute", inset: 0 }} className="bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

    {/* Selected badge */}
    {isSelected && (
      <div style={{ position: "absolute", top: "12px", right: "12px" }}
        className="bg-[#08757c] text-white text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-widest flex items-center gap-1">
        <span className="material-symbols-outlined text-[12px]">check_circle</span>
Selected      </div>
    )}

    {/* City name at bottom */}
    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }} className="p-4">
      <h3 className="text-base font-extrabold text-white leading-tight">{location.cityName}</h3>
      {isSelected && (
        <span
          className="material-symbols-outlined text-[#bbf46e] text-[18px] mt-1 block"
          style={{ fontVariationSettings: "'FILL' 1" }}
        >
          check_circle
        </span>
      )}
    </div>
  </button>
);

// ─────────────────────────────────────────────
// STEP 1 — SELECT LOCATION
// ─────────────────────────────────────────────

export default function LabBookingStep1Location({
  locations,
  selectedLocation,
  onSelect,
  error,
}) {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="bg-white p-4 rounded-2xl shadow-[0px_20px_40px_rgba(24,28,29,0.06)] border border-white/40">

      {error && (
        <p className="text-xs text-[#ba1a1a] mb-4 flex items-center gap-1">
          <span className="material-symbols-outlined text-[14px]">error</span>
          {error}
        </p>
      )}

      {locations.length === 0 ? (
        <p className="text-sm text-[#3e494a]">No locations found.</p>
      ) : (
        <>
          {/* First 8 as portrait cards — expands to every location (same
              card style, not a plain-text list) once "Load More" is hit. */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {(showAll ? locations : locations.slice(0, 8)).map((loc) => (
              <LocationCard
                key={loc.id}
                location={loc}
                isSelected={selectedLocation?.id === loc.id}
                onSelect={onSelect}
              />
            ))}
          </div>

          {locations.length > 8 && (
            <div className="flex justify-center mt-5">
              <button
                onClick={() => setShowAll((v) => !v)}
                className="flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#e4f2f2] text-[#08757c] text-sm font-bold hover:bg-[#08757c] hover:text-white transition-colors"
              >
                {showAll ? "Show Less" : "Load More"}
                <span className="material-symbols-outlined text-[18px]">
                  {showAll ? "expand_less" : "expand_more"}
                </span>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
